import { Checkbox as _Checkbox, CheckboxProps as _CheckboxProps } from 'antd'

import './Checkbox.css'

type CheckboxProps = _CheckboxProps

export function Checkbox({ className, ...props }: CheckboxProps) {
  return (
    <_Checkbox
      className={`customCheckbox ${className}`}
      {...props}
    />
  )
}
